// Meeting-level synopsis card. Renders at the top of MeetingReview,
// above the transcript turns. Carries the synopsis produced by the
// attribution Claude call (2-4 sentences explaining overall attribution
// logic). Null/empty when the transcript hasn't been re-annotated under
// the new pipeline.
//
// Spec: docs/superpowers/specs/2026-05-25-annotation-pipeline-redesign.md

import { useState } from "react";

interface MeetingSynopsisProps {
  synopsis: string | null;
}

export function MeetingSynopsis({ synopsis }: MeetingSynopsisProps) {
  const [expanded, setExpanded] = useState(true);

  if (!synopsis || !synopsis.trim()) {
    return null;
  }

  return (
    <section className="meeting-synopsis-card" aria-label="Attribution synopsis">
      <header className="meeting-synopsis-header">
        <span className="meeting-synopsis-label">Attribution synopsis</span>
        <button
          type="button"
          className="meeting-synopsis-toggle"
          onClick={() => setExpanded(!expanded)}
          aria-expanded={expanded}
        >
          {expanded ? "Hide" : "Show"}
        </button>
      </header>
      {expanded && (
        <div className="meeting-synopsis-body" dir="auto">
          {synopsis}
        </div>
      )}
    </section>
  );
}
